import PropTypes from 'prop-types';
import { useEffect } from 'react';
import debitCardSelector from 'selectors/debitCard';
import { isLoadingState } from 'reducers/loading';
import { load, LOAD } from 'model/debitCard';
import { selector as busySelector } from 'selectors/busy';
import { useDispatch, useSelector } from 'react-redux';
import AccountList from '../AccountsList';
import { columnMeta, detailsRender } from './config';

const SETTING_TYPE = 'debitCard';

const validateUIState = ({ isLoading, isBusy, items, hasError }) => {
  const validStates = [
    isLoading && !hasError && !items?.length,
    !isLoading && !hasError && items?.length > 0,
    !isLoading && !hasError && items?.length === 0,
    !isLoading && hasError && !items?.length,
  ];

  const isValid = validStates.some((state) => state);

  if (!isValid && process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.warn('DebitCards: Invalid UI state detected', {
      isLoading,
      isBusy,
      itemCount: items?.length ?? 0,
      hasError,
    });
  }

  return isValid;
};

const DebitCards = ({ fspId, payerId }) => {
  const dispatch = useDispatch();
  const isBusy = useSelector((state) => busySelector(state, LOAD));
  const isLoading = useSelector((state) => isLoadingState(state, LOAD.ACTION));
  const items = useSelector((state) => debitCardSelector(state, payerId));
  const error = useSelector((state) => {
    const loadState = state?.loading?.[LOAD.ACTION];
    return loadState?.error || null;
  });

  const hasError = Boolean(error);

  validateUIState({ isLoading, isBusy, items, hasError });

  const loadAction = (props) => {
    dispatch(load({ fspId, payerId, ...props }));
  };

  useEffect(() => {
    dispatch(load({ fspId, payerId }));
  }, [dispatch, fspId, payerId]);

  return (
    <AccountList
      actionConstant={LOAD}
      columnMeta={columnMeta}
      detailsRender={detailsRender}
      fspId={fspId}
      isBusy={isBusy}
      isLoading={isLoading}
      items={items}
      loadAction={loadAction}
      name="debitCards"
      payerId={payerId}
      settingType={SETTING_TYPE}
      title="Debit Cards"
    />
  );
};

DebitCards.propTypes = {
  fspId: PropTypes.number.isRequired,
  payerId: PropTypes.number.isRequired,
};

export default DebitCards;
